import React from 'react';

export const DefaultEventRootComponent = React.memo(
  React.forwardRef(function DefaultEventRootComponent(
    {
      isActive,
      handleDelete,
      cellIndex,
      rangeIndex,
      classes,
      disabled,
      ...props
    },
    ref,
  ) {
    return <div ref={ref} aria-disabled={disabled} {...props} />;
  }),
);